import { capturePostHog } from './posthogLazy.js';

// Helper function for TikTok tracking
export const trackTikTokEvent = (eventName, tiktokEvent) => {
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track(eventName, tiktokEvent);
  }
};

// Helper function for PostHog tracking (library loads lazily, never blocks)
export const trackPostHog = (eventName, properties = {}) => {
  if (typeof window !== 'undefined') {
    void capturePostHog(eventName, properties);
  }
}; 